import React from "react";
import { Table } from "react-bootstrap";

const FinancialReport = () => {

  const financialData = [
    {
      description: "Assets:",
      subtotal: "Total Non-Current Assets",
      items: [
        { description: "Non-current Assets:", notes: "", 2023: "", 2022: "" },
        {
          description: "Plants Properties & Equipment (PPE):",
          notes: "21",
          2023: 5132392,
          2022: 60214943,
        },
        {
          description: "Unclassified Assets",
          notes: "22",
          2023: 5132392,
          2022: 60214943,
        },
        {
          description: "Investment in Securities",
          notes: "23",
          2023: 60622831,
          2022: 458094,
        },
        {
          description: "Investment in Properties",
          notes: "24",
          2023: 60622831,
          2022: 458094,
        },
      ],
    },
    {
      description: "Current Assets:",
      subtotal: "Total Current Assets",
      subtotal2: "Total Assets",
      items: [
        {
          description: "Cash and Cash Equivalents",
          notes: "25",
          2023: 22008517,
          2022: 16314351,
        },
        {
          description: "Receivables",
          notes: "26",
          2023: 1143382,
          2022: 819992,
        },
        {
          description: "Inventories (Stock)",
          notes: "27",
          2023: 1143382,
          2022: 819992,
        },
      ],
    },
    {
      description: "Liabilities",
      subtotal: "Total Non-Current Liabilities",
      items: [
        {
          description: "Long-term Borrowing",
          notes: "28i",
          2023: 2385659,
          2022: 2328090,
        },
      ],
    },
    {
      description: "Non-current liabilities",
      subtotal: "Total liabilities",
      items: [
        {
          description: "Short-term Borrowing",
          notes: "28i",
          2023: 2385659,
          2022: 2328090,
        },
        {
          description: "Payables and Other Liabilities",
          notes: "28ii",
          2023: 2385659,
          2022: 2328090,
        },
        {
          description: "Total Current Liabilities",
          notes: "29",
          2023: 2385659,
          2022: 2328090,
        },
      ],
    },
    {
      description: "Net Assets/Equity",
      subtotal: "Total Net Assets/Equity",
      items: [
        {
          description: "Accumulated surplus",
          notes: "35",
          2023: 2385659,
          2022: 2328090,
        },
        { description: "", notes: "", 2023: 2385659, 2022: 2328090 },
      ],
    },
  ];

  // Function to calculate totals for 2023 and 2022
  const calculateTotals = (items) => {
    const total2023 = items.reduce((sum, item) => sum + (item[2023] || 0), 0);
    const total2022 = items.reduce((sum, item) => sum + (item[2022] || 0), 0);
    return { total2023, total2022 };
  };

  const numberStyle = {
    textAlign: "right",
    borderRight: "none",
  };

  return (
    <div className="container-fluid">
      <div
        className="header"
        style={{
          background: "linear-gradient(to right, #bc5449, white)",
          padding: "40px 50px 2px 50px",
          borderBottom: "4px solid #2E8B57",
          marginBottom: "15px",
          display: "flex",
          textAlign: "center",
        }}
      >
        <p
          className=""
          style={{ textTransform: "uppercase", textAlign: "right" }}
        >
          report of the accountant general with IPSAS accrual financial
          statement for the year ended 31st December, 2023
        </p>
      </div>
      <h1
        style={{
          paddingTop: "20px",
          fontSize: "24px",
          textAlign: "right",
          marginBottom: "20px",
        }}
      >
        Katsina State Government of Nigeria Consolidated Statement of Financial
        Position (Balance Sheet) As At 31st December, 2023
      </h1>
      <Table>
        <thead>
          <tr>
            <th
              className="text-center"
              style={{ borderLeft: "none", fontWeight: "bolder" }}
            >
              Description
            </th>
            <th>Notes</th>
            <th>
              2023 <br /> (N'000)
            </th>
            <th style={{ borderRight: "none" }}>
              2022 <br /> (N'000)
            </th>
          </tr>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <span>cash flows from operating Activities</span>
          </div>
        </thead>
        <tbody>
          {financialData.map((section, index) => {
            const totals = calculateTotals(section.items);
            return (
              <React.Fragment key={index}>
                <tr>
                  <td colSpan="4" className="bg-light font-weight-bold">
                    {section.description}
                  </td>
                </tr>
                {section.items.map((item, subIndex) => (
                  <tr key={subIndex}>
                    <td style={{ borderRight: "none" }}>{item.description}</td>
                    <td style={{ borderRight: "none" }}>{item.notes}</td>
                    <td style={numberStyle}>{item[2023]?.toLocaleString()}</td>
                    <td style={numberStyle}>{item[2022]?.toLocaleString()}</td>
                  </tr>
                ))}
                <tr>
                  <td className="font-weight-bold">{section.subtotal}</td>
                  <td></td>
                  <td
                    className="font-weight-bold"
                    style={{
                      ...numberStyle,
                      borderTop: "2px solid black",
                      borderBottom: "2px solid black",
                    }}
                  >
                    {totals.total2023.toLocaleString()}
                  </td>
                  <td
                    className="font-weight-bold"
                    style={{
                      ...numberStyle,
                      borderTop: "2px solid black",
                      borderBottom: "2px solid black",
                    }}
                  >
                    {totals.total2022.toLocaleString()}
                  </td>
                </tr>
                {section.subtotal2 && (
                  <tr>
                    <td className="font-weight-bold">{section.subtotal2}</td>
                    <td></td>
                    <td
                      className="font-weight-bold"
                      style={{
                        ...numberStyle,
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                    >
                      {totals.total2023.toLocaleString()}
                    </td>
                    <td
                      className="font-weight-bold"
                      style={{
                        ...numberStyle,
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                    >
                      {totals.total2022.toLocaleString()}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </Table>
      <div
        className="footer"
        style={{
          background: "linear-gradient(to right, #420D09, #990f02)",
          padding: "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: "5px",
            width: "30px",
            height: "30px",
            textAlign: "center",
          }}
        >
          1
        </div>
      </div>
    </div>
  );
};

export default FinancialReport;
